/**
 * Builds the WebSocket URL for an AI agent test/live call against the STT server.
 *
 * The STT server expects a `/ws/fs` endpoint with the call context supplied as
 * query params (agent, crm, caller/destination numbers, VAD tuning, etc.).
 * Connecting to the old `/?agent_id=X` path no longer works.
 *
 * The host is read from REACT_APP_AI_WSS_URL; the ws/wss scheme is derived from
 * the current page protocol so an https page never opens an insecure ws socket.
 *
 * Overridable via env:
 *   REACT_APP_AI_WSS_URL         host (with or without scheme) of the STT server
 *   REACT_APP_CRM_ID             fallback crm id when no logged-in company is available
 *   REACT_APP_CALLER_ID_NUMBER   caller id number (default 1111)
 *   REACT_APP_DESTINATION_NUMBER destination number (default 2222)
 */
const MIN_SILENCE_MS = '700';
const VAD_THRESHOLD = '0.7';

const newSessionId = () =>
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const buildAiAgentWsUrl = (agentId, { language, crmId } = {}) => {
  if (!agentId) return null;

  const base = process.env.REACT_APP_AI_WSS_URL || 'ws://62.171.170.48:8085';
  const host = base.replace(/^wss?:\/\//i, '').replace(/\/+$/, '');
  const effectiveCrmId = crmId ?? process.env.REACT_APP_CRM_ID ?? '0';
  const callerId = process.env.REACT_APP_CALLER_ID_NUMBER || '1111';
  const destNumber = process.env.REACT_APP_DESTINATION_NUMBER || '2222';
  const langHint = language || 'auto';
  const scheme = window.location.protocol === 'https:' ? 'wss' : 'ws';

  const qs = new URLSearchParams({
    lang_hint: langHint,
    crm_id: String(effectiveCrmId),
    caller_id_number: callerId,
    destination_number: destNumber,
    agent_id: String(agentId),
    session_id: newSessionId(),
    min_silence_ms: MIN_SILENCE_MS,
    vad_threshold: VAD_THRESHOLD,
    interim_results: 'false'
  });

  return `${scheme}://${host}/ws/fs?${qs.toString()}`;
};
